import styled from 'styled-components';

export const ChildWrapper = styled.div``;
